import React from "react";
import { View, StyleSheet } from "react-native";

import { createStackNavigator } from "react-navigation-stack";

import {
  AreaListScreen,
  AreaFormScreen,
  AreaRemoveScreen,
  AreaLogScreen,
  CameraFormScreen,
  CameraViewScreen,
  CameraMultiViewScreen,
  DeviceListScreen,
  DeviceFormScreen,
  GPIOFormScreen,
  DeviceAddScreen,
  DeviceLogScreen,
  UserListScreen,
  UserAccessScreen,
  AddUserScreen,
  UpdateGuestExpireScreen,
  ScenarioListScreen,
  ScenarioFormScreen,
  ScenarioReportScreen,
  AreaPowerMeterScreen,
  AreaWaterMeterScreen,
  ElevatorFormScree,
  AreaStateListScreen,
  AreaStateFormScreen,
  AboutUsScreen,
  UserMessagesScreen,
  SmartSpeakerFormScreen,
  MediaPlayListFormScreen,
  ParkingListScreen,
  ParkingLotListScreen,
  ParkingReservationFormScreen,
  ParkingReservationListScreen,
  TouchPanelFormScreen,
  AccessControlForm,
  DeviceFormControllerScreen,
} from "../screens";
import AreaUsersScreen from "../screens/AreaUsersScreen";
import {
  HomeScreen,
  LoginScreen,
  ResetPasswordScreen,
  SignInScreen,
  WelcomeScreen,
  AddBuildingScreen,
} from "../screens_v2";
import {
  MyOrdersScreen,
  CarWashScreen,
  RestaurantAndCoffeeShopScreen,
  IncreaseCreditScreen,
  ParkingScreen,
  EditRibbonUserAccessLevelScreen,
} from "../api/_index";

import {
  SettingsListScreen,
  UpdateScreen,
  ServersListScreen,
  AccountScreen,
} from "../screens/settingsScreens";

import { translate } from "../locales/translate";
import ArTheme from "../argon-ui/Theme";
import DeviceToAreaScreen from "../screens/DeviceToAreaScreen";

import SmartParkingFormScreen from "../screens/SmartParkingFormScreen";
var AppStyle = require("../styles/Style");

const headerStyle = StyleSheet.create({
  title: { alignSelf: "flex-start", fontFamily: "IRANSansWebFaNum" },
});

const drawerNavigationOption = ({ navigation }) => ({
  headerTintColor: ArTheme.COLORS.WHITE,
  headerStyle: AppStyle.topHeader,
  title: "Taplife",
  headerShown: false,
  // headerTitleStyle: { alignSelf: "flex-end" , color: "red" },
  // headerRight: () => (
  //   <TouchableOpacity onPress={() => navigation.toggleDrawer()}>
  //     <View>
  //       <FontAwesomeIcon style={AppStyle.navToggle} size={26} icon={faCharCode.faBars} />
  //     </View>
  //   </TouchableOpacity>
  // ),
});

const FlatStackNavigation = createStackNavigator({
  Home: {
    screen: HomeScreen,
    navigationOptions: { ...drawerNavigationOption, headerShown: false },
  },
  Welcome: {
    screen: WelcomeScreen,
    navigationOptions: { ...drawerNavigationOption, headerShown: false },
  },
  Login: {
    screen: LoginScreen,
    navigationOptions: { ...drawerNavigationOption, headerShown: false },
  },
  ResetPasswordScreen: {
    screen: ResetPasswordScreen,
    navigationOptions: { ...drawerNavigationOption, headerShown: false },
  },
  SignInScreen: {
    screen: SignInScreen,
    navigationOptions: { ...drawerNavigationOption, headerShown: false },
  },
  CameraView: {
    screen: CameraViewScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  CameraMultiView: {
    screen: CameraMultiViewScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Scenarios: {
    screen: ScenarioListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ScenarioList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AboutUs: {
    screen: AboutUsScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AboutUs"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaPowerMeter: {
    screen: AreaPowerMeterScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreaPowerMeter"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaWaterMeter: {
    screen: AreaWaterMeterScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreaWaterMeter"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaStates: {
    screen: AreaStateListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreaStates"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaStateForm: {
    screen: AreaStateFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreaStates"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Setting: {
    screen: SettingsListScreen, // use connect() to connect screen to redux store
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.Setting"),
      headerTitleStyle: headerStyle.title,
    },
  },
  ServersList: {
    screen: ServersListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("user_profile.serversList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Account: {
    screen: AccountScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.Account"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Updates: {
    screen: UpdateScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.Setting"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Areas: {
    screen: AreaListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreasList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaForm: {
    screen: AreaFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreasList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaRemove: {
    screen: AreaRemoveScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreaRemove"),
      headerTitleStyle: headerStyle.title,
    },
  },
  DeviceToArea: {
    screen: DeviceToAreaScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreasList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaLogs: {
    screen: AreaLogScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreasList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Users: {
    screen: UserListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.UserList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  UserAccess: {
    screen: UserAccessScreen,
    navigationOptions: {
      index: 0,
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.UserList"),
      headerTitleStyle: headerStyle.title,
      headerLeft: <View></View>,
    },
  },
  AddUser: {
    screen: AddUserScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.UserList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  GuestExpire: {
    screen: UpdateGuestExpireScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.UserList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Devices: {
    screen: DeviceListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },

  DeviceForm: {
    screen: DeviceFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  DeviceFormController: {
    screen: DeviceFormControllerScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  GPIOForm: {
    screen: GPIOFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  SmartSpeakerForm: {
    screen: SmartSpeakerFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  MediaPlayListForm: {
    screen: MediaPlayListFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.MediaPlayListForm"),
      headerTitleStyle: headerStyle.title,
    },
  },
  DeviceAdd: {
    screen: DeviceAddScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceAdd"),
      headerTitleStyle: headerStyle.title,
    },
  },
  DeviceToArea: {
    screen: DeviceToAreaScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  DeviceLogs: {
    screen: DeviceLogScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  CameraForm: {
    screen: CameraFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  ElevatorForm: {
    screen: ElevatorFormScree,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  SmartParkingForm: {
    screen: SmartParkingFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.DeviceList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Scenarios: {
    screen: ScenarioListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ScenarioList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Parkings: {
    screen: ParkingListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.Parkings"),
      headerTitleStyle: headerStyle.title,
    },
  },
  ParkingLotsListScreen: {
    screen: ParkingLotListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ParkingLot"),
      headerTitleStyle: headerStyle.title,
    },
  },
  ParkingResevetionForm: {
    screen: ParkingReservationFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ParkingReservation"),
      headerTitleStyle: headerStyle.title,
    },
  },
  // ParkingLotForm: {
  //   screen: ParkingLotFormScreen,
  //   navigationOptions: {
  //     ...drawerNavigationOption,
  //     headerShown: true,
  //     title: translate("navigation.ParkingLotForm"),
  //     headerTitleStyle: headerStyle.title,
  //   },
  // },
  ParkingReservationList: {
    screen: ParkingReservationListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ParkingReservationList"),
      headerTitleStyle: headerStyle.title,
    },
  },

  ScenarioList: {
    screen: ScenarioListScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ScenarioList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  ScenarioForm: {
    screen: ScenarioFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ScenarioList"),
      headerTitleStyle: headerStyle.title,
    },
  },
  ScenarioReport: {
    screen: ScenarioReportScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.ScenarioReportScreen"),
      headerTitleStyle: headerStyle.title,
    },
  },
  Parking: {
    screen: ParkingScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.Parking"),
      headerTitleStyle: headerStyle.title,
    },
  },
  EditRibbonUserAccessLevel: {
    screen: EditRibbonUserAccessLevelScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShow: true,
      title: translate("navigation.EditRibbonUserAccessLevel"),
      headerTitleStyle: headerStyle.title,
    },
  },
  AreaUsers: {
    screen: AreaUsersScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.AreaUsers"),
      headerTitleStyle: headerStyle.title,
    },
  },
  IncreaseCredit: {
    screen: IncreaseCreditScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.IncreaseCredit"),
      headerTitleStyle: headerStyle.title,
    },
  },
  RestaurantAndCoffeeShop: {
    screen: RestaurantAndCoffeeShopScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.RestaurantAndCoffeeShop"),
      headerTitleStyle: headerStyle.title,
    },
  },
  CarWash: {
    screen: CarWashScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.CarWash"),
      headerTitleStyle: headerStyle.title,
    },
  },
  PublicServices: {
    screen: MyOrdersScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.PublicServices"),
      headerTitleStyle: headerStyle.title,
    },
  },
  UserMessages: {
    screen: UserMessagesScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("navigation.UserMessages"),
      headerTitleStyle: headerStyle.title,
    },
  },
  // === Building ===
  AddBuilding: {
    screen: AddBuildingScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("building.addBuilding"),
      headerTitleStyle: headerStyle.title,
    },
  },
  // === Touch Panel ===
  TouchPanelForm: {
    screen: TouchPanelFormScreen,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("touchPanel.touchPanel"),
      headerTitleStyle: headerStyle.title,
    },
  },
  // === Access control ===
  AccessControlForm: {
    screen: AccessControlForm,
    navigationOptions: {
      ...drawerNavigationOption,
      headerShown: true,
      title: translate("device.accessControl"),
      headerTitleStyle: headerStyle.title,
    },
  },
});

const Navigator = createStackNavigator({
  Welcome: {
    screen: FlatStackNavigation,
    navigationOptions: {
      ...drawerNavigationOption,
      headerTintColor: ArTheme.COLORS.BLACK,
      headerStyle: AppStyle.topHeader,
      //title: translate("navigation.Setting"),
      headerShown: false,
      headerTitleStyle: { alignSelf: "flex-end" },
    },
  },
});

export default Navigator;
